import { useCallback, useEffect } from "react";
import { Form, FormikProps, withFormik } from "formik";
import * as yup from "yup";

// import { earliestLetterSendDate } from "../../../../model/dates";

// import { config } from "../../../../config";
import {
  FormSectionLetterRecipient,
  validationRules,
  IDefaultValuesModel as FormModel,
} from "../../form-sections/letter/form-section-letter-recipient";
import { FormSubmitRow } from "../../../molecules/form-submit-row";
import { ISelectOption } from "@santa/common/lib/utils/form";

const validationSchema = yup.object(validationRules);
export type LetterSendingValidatedFormModel = yup.Asserts<typeof validationSchema>;

interface IOwnProps {
  defaultValues: FormModel;
  surchargeNotice?: string;
  countryOptions: ISelectOption[];
  timezoneOptions: ISelectOption[];
  hasAddOn?: boolean;
  onChangeAddressCountry(urn: string): void;
  onChangePhoneCountry(setTimezone: (value: string) => void, urn: string): void;
  onChange(values: LetterSendingValidatedFormModel): void;
  onSubmit(values: LetterSendingValidatedFormModel): void;
  onClickBack(): void;
  onClickOpenMobilePreview(): void;
}

type Props = FormikProps<FormModel> & IOwnProps;

const C: React.FC<Props> = ({
  values,
  errors,
  touched,
  surchargeNotice,
  countryOptions,
  timezoneOptions,
  onChangeAddressCountry,
  onChangePhoneCountry,
  setFieldValue,
  submitForm,
  onClickBack,
  onChange,
}) => {
  // we need to use validationSchema method as Formik's 'isValid' property is not always up to date
  const isValid = validationSchema.isValidSync(values);

  useEffect(() => {
    if (isValid) {
      onChange(validationSchema.cast(values) as LetterSendingValidatedFormModel);
    }
  }, [values, isValid]);

  const handleChangePhoneCountry = useCallback(
    (urn: string): void =>
      onChangePhoneCountry((u: string) => setFieldValue("phoneTimezoneUrn", u), urn),
    [onChangePhoneCountry, setFieldValue],
  );

  return (
    <Form>
      <FormSectionLetterRecipient
        touched={touched}
        errors={errors}
        values={values}
        onChangeAddressCountry={onChangeAddressCountry}
        onChangePhoneCountry={handleChangePhoneCountry}
        countryOptions={countryOptions}
        timezoneOptions={timezoneOptions}
        setFieldValue={setFieldValue}
        surchargeNotice={surchargeNotice}
        hideSendDate={true}
      />

      <FormSubmitRow
        isSubmitEnabled={isValid}
        onClickSubmit={submitForm}
        onClickBack={onClickBack}
      />
    </Form>
  );
};

export const SantaLetterDetailsSendingForm = withFormik<IOwnProps, FormModel>({
  validationSchema,
  mapPropsToValues: props => props.defaultValues,
  validateOnMount: true,
  handleSubmit: (values, formik) =>
    formik.props.onSubmit(validationSchema.cast(values) as LetterSendingValidatedFormModel),
})(C);
